import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const initialState = {
  isAuthenticated: false,
  idToken: null,
  refreshToken: null,
  expiresIn: null,
  tokenExpiresAt: null,
  adminAccess: false,
  isLoading: false,
  custom_permissions: null,
  mfaChallenge: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticate: (state, action) => {
      // const payload = action.payload;
      //
    },
    deAuthenticate: (state) => {
      state.isAuthenticated = false;
      state.idToken = null;
      state.refreshToken = null;
      state.expiresIn = null;
      state.tokenExpiresAt = null;
      state.mfaChallenge = null;
    },
    setMfaChallenge: (state, action) => {
      state.mfaChallenge = action.payload;
    },
    clearMfaChallenge: (state) => {
      state.mfaChallenge = null;
    },
    setAuthenticationStatus: (state, action) => {
      state.mfaChallenge = null;
      if (action.payload) {
        const payloadData = action.payload.data || action.payload;
        const perms = payloadData?.custom_permissions;
        const rawExpiresIn =
          payloadData?.expiresIn ||
          payloadData?.expires_in;
        const expiresInSec = rawExpiresIn ? Number(rawExpiresIn) : (state.expiresIn || 3600);

        state.isAuthenticated = true;
        state.idToken =
          payloadData?.idToken ||
          payloadData?.token ||
          payloadData?.access ||
          payloadData?.sessionToken ||
          state.idToken;
        state.refreshToken =
          payloadData?.refreshToken ||
          payloadData?.refresh ||
          state.refreshToken;
        state.expiresIn = expiresInSec;
        state.tokenExpiresAt = Date.now() + expiresInSec * 1000;
        state.adminAccess =
          payloadData?.is_superuser !== undefined
            ? payloadData.is_superuser
            : (state.adminAccess !== undefined ? state.adminAccess : true);
        state.custom_permissions = Array.isArray(perms)
          ? perms
          : (perms ? [perms] : state.custom_permissions || []);
      } else {
        state.isAuthenticated = false;
      }
    },
    setIsLoading: (state, action) => {
      return { ...state, isLoading: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
  },
});

export const {
  authenticate,
  deAuthenticate,
  setMfaChallenge,
  clearMfaChallenge,
  setAuthenticationStatus,
  setIsLoading,
} = authSlice.actions;
export default authSlice.reducer;
